<!-- <div *ngIf="message" class="modal" tabindex="-1" role="dialog" style="display:block!important">
    <div class="modal-dialog custom-alert" role="document">
        <div class="modal-content">
            <div *ngIf="message?.type == 'confirm'" class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-center confirm-message">{{message.text}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p class="confirm-button">
                            <a (click)="message.siFn()">
                                <button class="btn btn-yes">Yes</button>
                            </a>
                            <a (click)="message.noFn()">
                                <button class="btn btn-no">No</button>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
    <div *ngIf="message"  class="swal2-container swal2-center swal2-shown" style="overflow-y: auto;">
        <div *ngIf="message?.type == 'confirm'" aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
            <div class="swal2-header">            
                <div class="swal2-icon swal2-warning swal2-animate-warning-icon" style="display: flex;"></div>
                <div class="swal2-icon swal2-success" style="display: none;">
                    <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
                        <span class="swal2-success-line-tip"></span> 
                        <span class="swal2-success-line-long"></span>
                        <div class="swal2-success-ring"></div> 
                        <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
                        <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
                </div>
                        <img class="swal2-image" style="display: none;">
                        <h2 class="swal2-title" id="swal2-title" style="display: flex;">{{message.text}}</h2>
                        <button type="button" class="swal2-close" aria-label="Close this dialog" style="display: none;">×</button>
            </div>
           
                
            <div class="swal2-actions">
                <button type="button" (click)="message.siFn()" class="swal2-confirm btn btn-success mt-2" aria-label="" style="display: inline-block;">
                    Yes, proceed!
                </button>
                <button type="button" (click)="message.noFn()" class="swal2-cancel btn btn-danger ml-2 mt-2" aria-label="" style="display: inline-block;">
                    No, cancel!
                </button>
            </div>
            <div class="swal2-footer" style="display: none;">
                
            </div>
        </div>
    </div>

    <!-- <div class="cd-popup" role="dialog" *ngIf="message">
        <div class="cd-popup-container" *ngIf="message?.type == 'confirm'">
            <p>{{message.text}}</p>
            <ul class="cd-buttons">
                <li><a (click)="message.noFn()">Yes</a></li>
                <li><a (click)="message.noFn()">No</a></li>
            </ul>
            <a href="#0" class="cd-popup-close img-replace">Close</a>
        </div> 
    </div> -->
